/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function showQuotes() {
  const params = new URL(document.location).searchParams;
  const quotes = document.getElementById('saved-quotes-wrapper');
  const orders = document.getElementById('orders');
  const menu = document.getElementById('account-selector');
  
  if (params.get('quotes') === 'true' && quotes) {
    const prevLink = menu.querySelector('.is-selected');
    const link = menu.querySelector('[href$="quotes=true"]');
    prevLink.classList.remove('is-selected');
    link.classList.add('is-selected');
    quotes.style.display = 'block';
    orders.style.display = 'none';
  }
}

if (document.location.pathname === window.Shopify?.routes?.root + 'account') document.addEventListener('DOMContentLoaded', showQuotes);


// For judgeme review widget.
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.jdgm-rev-widg__other-content *').forEach(function(btn) {
    btn.addEventListener('click', function (e) {
    setTimeout(function(){ 
      let elem = document.querySelectorAll('.jdgm-rev-widg__reviews')[1];
      let msnry = new Masonry( elem, { itemSelector:".jdgm-rev",columnWidth:".jdgm-rev",gutter:16,transitionDuration:"0.25s" });
    }, 600);
  });
    });
});

document.addEventListener('DOMContentLoaded', function() {
  $(".safe_secure").click(function(){
    $(".safe_secure p").toggle();
  })
})

document.addEventListener('click', (event) => {
    const popup = document.querySelector('.safe_secure p');
    if(popup.style.display != 'none' && event.target.className != 'safe_secure' && event.target.parentElement.className != 'safe_secure' && event.target.className != 'safe_secure ssmini' && event.target.parentElement.className != 'safe_secure ssmini'){
      $(".safe_secure p").hide();
    }
});
